/*
* @Author: 黄智强
* @Date: 2018-05-03 10:01:00
* @Last Modified by: 陈航
* @Last Modified time: 2018-12-20 13:47:35
* @说明：主程序
*/

import Vue from 'vue'

import api from './api/index'
import App from './App'
import router from './router'
import store from './store'
import formatMoney from './plugins/formatMoney'
import formValidate from './plugins/formValidate'
import WebUploader from './plugins/initWebUploader'
import showToast from './plugins/showToast'
import scrollPlugin from './plugins/willScrollToBottom'
import isWxBrowser from './plugins/isWxBrowser'


import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'


import './plugins/input.js'

Vue.use(ToastPlugin, { time: 1000, width: 'auto' })
Vue.use(LoadingPlugin)


Vue.use(api)


Vue.use(formatMoney)


Vue.use(formValidate)


Vue.use(WebUploader)


Vue.use(showToast)


Vue.use(scrollPlugin)



Vue.use(isWxBrowser)




Vue.$vux.loading.hide()



const routerFiles = [{'1': 'store'}, {'3': 'myBuy'}, {'4': 'service'}]
router.beforeEach((to, from, next) => {

if (to.query.access_token && to.query.access_token !== 'undefined') localStorage.access_token = to.query.access_token

if (to.query.auth_id && to.query.auth_id !== 'undefined') localStorage.auth_id = to.query.auth_id

let token = localStorage.access_token
let notNeedAuth = to.meta && to.meta.notNeedAuth
if (!notNeedAuth && !token) {
next('/')
return false
}

let navTabIndex = 0
routerFiles.map((item, index) => {
for (let _key in item) {
let routerPrefix = item[_key] + '_'
if (to.path.includes(routerPrefix)) navTabIndex = Number(_key)
}
})
if (to.path.toLowerCase().includes('store_shopcart')) {
store.dispatch('CHANGE_NAV_INDEX', 2)
} else {
store.dispatch('CHANGE_NAV_INDEX', navTabIndex)
}
next()
})

window._isPhone = /^[1][3,4,5,7,8,9][0-9]{9}$/ 

Vue.config.productionTip = false

/* eslint-disable no-new */

new Vue({
el: '#app',
router,
store,
components: { App },
template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js